import defaultClient from '@src/api/clients/default';

export function fetchClientCreativeKnowledge(params = {}) {
  return defaultClient.request({
    url: 'dashboard/client-creative-knowledge/',
    method: 'GET',
    payload: params,
  });
}

export function createClientCreativeKnowledge(payload) {
  return defaultClient.request({
    url: 'dashboard/client-creative-knowledge/',
    method: 'POST',
    payload,
  });
}

export function updateClientCreativeKnowledge(id, payload) {
  return defaultClient.request({
    url: `dashboard/client-creative-knowledge/${id}/`,
    method: 'PATCH',
    payload,
  });
}

export function deleteClientCreativeKnowledge(id) {
  return defaultClient.request({
    url: `dashboard/client-creative-knowledge/${id}/`,
    method: 'DELETE',
  });
}
